// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"104":"component---src-components-project-detail-project-detail-js","125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"104":"aabefee2ca44012aaad2","125":"b750f49c480a2221c862","293":"abd73a945a5a6a028c1d","522":"e727575accda5711d874"}[chunkId] + ".js";
};